import { createFileRoute } from '@tanstack/react-router';
import { LetterheadPage } from '../../features/documents';

export const Route = createFileRoute('/portal/documents/letterhead')({ component: LetterheadPage });
